<!------------------------------------------------------------------------------
- Copyright (c) 2019. BMW Group. All rights reserved.
----------------------------------------------------------------------------->

@if (showCloseButton) {
  <div (click)="delete()"
    class="close"
    data-cy="additional-close-button">
    <span class="iwp-icon-gen_close_l"></span>
  </div>
}

<div class="container {{containerTypeClass}}"
  [attr.data-cy]="baseCypressTag">
  <ng-content></ng-content>
</div>
